import axios from 'axios';

export async function updateApplicant(applicationSecureId, prospect) {
  try {
    if (applicationSecureId === null) {
      return await axios.post(`${process.env.REACT_APP_MCCC_API_URL}/refi/prospect`, prospect);
    }
    return await axios.put(
      `${process.env.REACT_APP_MCCC_API_URL}/refi/prospect/${applicationSecureId}`,
      prospect,
    );
  } catch (error) {
    return error.response.status;
  }
}

export async function unsubscribeApplicant(applicationSecureId) {
  try {
    if (applicationSecureId !== null) {
      return await axios.patch(`${process.env.REACT_APP_MCCC_API_URL}/refi/prospect/${applicationSecureId}/unsubscribe`);
    }
    return null;
  } catch (error) {
    return error.response.status;
  }
}
